import { render, staticRenderFns } from "./ExamTakerDetails.vue?vue&type=template&id=70139fb4"
import script from "./ExamTakerDetails.vue?vue&type=script&lang=js"
export * from "./ExamTakerDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports